const MINUS = "−";

/** "12.5%", "−3%": unsigned when positive, a true minus when negative. */
export const formatPercent = (value: number, digits = 1) =>
  `${Number(value.toFixed(digits)) < 0 ? MINUS : ""}${Math.abs(value).toFixed(
    digits
  )}%`;

/** "+12.5%", "−3.0%", "0.0%". */
export const formatSignedPercent = (value: number, digits = 1) =>
  `${Number(value.toFixed(digits)) > 0 ? "+" : ""}${formatPercent(
    value,
    digits
  )}`;
